export const CREATE_SUB_JOB_ISSUE = 'CREATE_SUB_JOB_ISSUE';
export const GET_SUB_JOB_ISSUES = 'GET_SUB_JOB_ISSUES';
export const SUB_JOB_ISSUE_REQUEST = 'SUB_JOB_ISSUE_REQUEST';
export const UPDATE_SUB_JOB_ISSUE = 'UPDATE_SUB_JOB_ISSUE';
export const DELETE_SUB_JOB_ISSUE = 'DELETE_SUB_JOB_ISSUE';
export const SUB_JOB_ISSUE_REQUEST_FAILURE = 'SUB_JOB_ISSUE_REQUEST_FAILURE';